import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-insufficient-funds',
  standalone: true,
  imports: [CommonModule,ButtonModule],
  templateUrl: './insufficient-funds.component.html',
  styleUrl: './insufficient-funds.component.css'
})
export class InsufficientFundsComponent {
  constructor(private router:Router) {}
  retry() {
    this.router.navigate(['/unavailable']);
    console.log('Retry clicked');
  }

}
